// extracted by css-extract-rspack-plugin
export default {"root":"yQdP1","advisoryList":"djIEZ","emptyRoot":"pDIhR","countBadge":"C6GZb"};